import { render } from "./MEMBER_UPDATE_ABOUT_EMPTY.vue?vue&type=template&id=20340a62"
import script from "./MEMBER_UPDATE_ABOUT_EMPTY.vue?vue&type=script&lang=js"
export * from "./MEMBER_UPDATE_ABOUT_EMPTY.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__